<div class="toast-container">
  @for (notification of notifications$ | async; track notification.id) {
    <div class="toast-item" [@toastAnimation]>
      <app-alert-label
        [icon]="notification.icon"
        [boxStyle]="notification.type"
        [showCloseButton]="true"
        (closedChange)="onDismiss(notification)">
        {{ notification.message }}
        @if (notification.action; as action) {
          <button suffix class="action-button" type="button" (click)="onAction(notification, action.run)">{{ action.label }}</button>
        }
        @if (notification.link; as link) {
          <a class="inline-link toast-link" [routerLink]="link.route" (click)="onDismiss(notification)">{{ link.label }}</a>
        }
      </app-alert-label>
    </div>
  }
</div>